module.exports = __webpack_public_path__ + "img/dash-card-bg-2.52334e12.svg";